import { Component } from '@poa/core';
import { action, observable, Observer } from '@poa/state';
import debounce from 'lodash/debounce';
import React from 'react';
import { DateRangePicker } from 'react-dates';
import { arrayMove } from 'react-sortable-hoc';
import ColumnsContainer, { ColumnItem } from './columns-settings';
import Dropdown from './dropdown';
import LikeIcon from './icons/like';
import SearchIcon from './icons/search';
import { ACCESS_LEVEL } from '../store/auth/auth.constants';
import { ReactComponent as FilterToggle } from '../img/svgo/filter-tool.svg';
import { PrefetchSelect } from './profile-modal/tabs/profile-tab-form';

const DEBOUNCE_SEARCH_TIME = 950; // ms

export const PageMode = {
  statistics: 'statistics',
  fines: 'fines'
};

export const PageModeTransfers = {
  teamlead: 'teamlead',
  operator: 'operator',
  manager: 'manager'
};

export const PageModeCalendar = {
  accounts: 'accounts',
  operators: 'operators',
  clients: 'clients'
};

export const PageModeWallet = {
  wallet: 'wallet',
  transactions: 'transactions',
};

export const DateModeCalendar = {
  days: 'days',
  monthes: 'monthes',
};

export const PageModeReports = {
  reports: 'reports',
  charts: 'charts'
};

class TableFilter extends React.Component {
  t; // injected by Poa

  static defaultProps = {
    state: {
      grouping: {
        options: [],
        selected: { value: 'none', label: 'нет' }
      },
      status: {
        selected: { value: 'none', label: 'нет' },
        options: []
      },
      columnSettings: {
        selectedPreset: { label: 'по умолчанию' },
        availablePresets: [],
        columns: []
      }
    },
    onStatusChange: () => {},
    onDatesChange: () => {},
    selectors: {},
    onPageModeChange: null
  };

  localState = observable({
    showNav: false
  });

  toggleNavItems = action(() => {
    this.localState.showNav = !this.localState.showNav;
  });

  focusedDateInput = observable(null);

  handleDatepickerFocusChange = focusedInput => this.focusedDateInput.set(focusedInput);

  handleFractionalChange = e => this.props.onIsFractionalChange(e.target.value === 'decimal');

  onSearchChangeDebounced = debounce(v => this.props.onSearchChange(v), DEBOUNCE_SEARCH_TIME);

  handleSearch = ({ target }) => {
    this.onSearchChangeDebounced(target.value);
  };

  renderGroupingOption = (d, i) => {
    const { state, onGroupingChange } = this.props;

    return this.renderOption(d, i, state.grouping.selected, onGroupingChange);
  };

  renderFilteringOption = (d, i) => {
    const { state, onFilteringChange } = this.props;
    return this.renderOption(d, i, state.filtering.selected, onFilteringChange);
  };

  renderStatusOption = (d, i) => {
    const { state, onStatusChange } = this.props;

    return this.renderOption(d, i, state.status.selected, onStatusChange);
  };

  renderColumnPresetOption = (d, i) => {
    const { onColumnPresetChange, deletePreset } = this.props;
    const isActive = this.props.selectors.selectedPreset === d;

    let className = 'common-filter__btn';

    if (isActive) {
      className += ' is-active';
    }

    return (
      <button key={i} className={className} onClick={() => onColumnPresetChange(d.id)}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>{d.label}</div>
          {// ignore default preset
            d.id !== 0 && (
              <div
                style={{ cursor: 'pointer' }}
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();

                  deletePreset(d.id);
                }}
              >
                <i className='material-icons' style={{ fontSize: 17 }}>
                  delete
                </i>
              </div>
            )}
        </div>
      </button>
    );
  };

  renderOption(d, i, selected, onClick) {
    let className = 'common-filter__btn';

    if (selected === d) {
      className += ' is-active';
    }
    return (
      <button key={i} className={className} onClick={() => onClick(d)}>
        {d.label}
      </button>
    );
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.props.changePresetOrder(
      arrayMove(this.props.selectors.currentPresetColumnsList, oldIndex, newIndex)
    );
  };

  render() {
    const {
      state,
      onDatesChange,
      withoutFractionalChange,
      withoutDatesChange,
      withoutStatusChange,
      withoutGroupingChange,
      withoutFilteringChange,
      withAdd = false,
      withSearch = true,
      withTransferSearch = false,
      withColumnsConfigure = true,
      onAdd,
      onPageModeChange,
      onPageModeTransfersChange,
      onPageModeCalendarChange,
      onDateModeCalendarChange,
      onFilterCalendarChange,
      onPageModeReportsChange
    } = this.props;

    const isManagerOrAgency =
      this.store.auth.accessLevel === ACCESS_LEVEL.agency ||
      this.store.auth.accessLevel === ACCESS_LEVEL.manager;

    return (
      <div className='filters'>
        <div className='filter-icon' onClick={this.toggleNavItems}>
          <FilterToggle />
        </div>
        <div className={`filter-list  ${this.localState.showNav && 'active'}`}>
        <div className='filters__inner inner'>
          {(!withoutDatesChange ||
              !withoutFilteringChange ||
              !withoutGroupingChange ||
              !onFilterCalendarChange ||
              !withoutStatusChange) &&
            <div className='filters__left'>
              {!withoutDatesChange && (
                <div className='filter'>
                  <span className='filter__label'>{this.t('period')}</span>
                  <DateRangePicker
                    disabled={this.props.datesDisabled}
                    startDateId='1'
                    endDateId='1'
                    isOutsideRange={() => false}
                    startDate={state.startDate}
                    startDatePlaceholderText={this.t('from')}
                    endDate={state.endDate}
                    endDatePlaceholderText={this.t('to')}
                    onDatesChange={onDatesChange}
                    focusedInput={this.focusedDateInput.get()}
                    onFocusChange={this.handleDatepickerFocusChange}
                    customArrowIcon='-'
                    minimumNights={0}
                    hideKeyboardShortcutsPanel={true}
                  />
                </div>
              )}

              {(onFilterCalendarChange && isManagerOrAgency)? (
                <div className='filter team-lead-filter'>
                  <PrefetchSelect
                          editMode={true}
                          type='teamleads'
                          current={state.teamLead}
                          AccountId={null}
                          onChange={value => (state.teamLead = value ? value : null)}
                        />
                </div>
              ) : null}
              {!withoutFilteringChange && (
                <Dropdown label={this.t('filtering')} selected={state.filtering.selected.label}>
                  {state.filtering.options.map(this.renderFilteringOption)}
                </Dropdown>
              )}
              {!withoutGroupingChange && (
                <Dropdown label={this.t('grouping')} selected={state.grouping.selected.label}>
                  {state.grouping.options.map(this.renderGroupingOption)}
                </Dropdown>
              )}
              {!withoutStatusChange && (
                <Dropdown
                  label={this.t('status')}
                  selected={
                    <span>
                      <span className='point' />
                      {state.status.selected.label}
                    </span>
                  }
                >
                  {state.status.options.map(this.renderStatusOption)}
                </Dropdown>
              )}
            </div>
          }
          {(withColumnsConfigure ||
              !withoutFractionalChange ||
              onPageModeChange ||
              onPageModeTransfersChange ||
              onPageModeCalendarChange ||
              onDateModeCalendarChange ||
              onPageModeReportsChange ||
              withSearch ||
              withTransferSearch ||
              withAdd) &&
            <div className='filters__right'>
              {withColumnsConfigure && (
                <Dropdown
                  label={this.t('columns')}
                  selected={this.props.selectors.selectedPreset.label}
                  render={isOpen => (
                    <div className='filter-columns'>
                      <div className='filter-columns__top'>
                        {state.columnSettings.availablePresets.map(this.renderColumnPresetOption)}
                      </div>
                      <div className='filter-columns__top' style={{ borderBottom: '1px solid #ccc' }}>
                        <label
                          className='filter-columns__row'
                          style={{ padding: '5px 25px', margin: 0, width: '208px' }}
                        >
                          <input
                            type='checkbox'
                            name='all'
                            className='filter-columns__check'
                            checked={this.props.selectors.isAllColumnsSelected}
                            onChange={async () => {
                              await this.props.onAllColumnsToggle();
                              this.props.getTableNode().recalculateScroll();
                            }}
                          />
                          <ColumnItem
                            item={{ label: this.t('all') }}
                            hideDragHandle
                            isDropdownOpen={isOpen}
                          />
                          <span className='filter-columns__checkbox'>
                            <LikeIcon />
                          </span>
                        </label>
                      </div>
                      <div className='filter-columns__bot'>
                        <ColumnsContainer
                          {...this.props}
                          getTableNode={this.props.getTableNode}
                          columns={this.props.selectors.selectedPreset.columnsConfiguration}
                          onSortEnd={this.onSortEnd}
                          isDropdownOpen={isOpen}
                        />
                      </div>
                    </div>
                  )}
                />
              )}
              {!withoutFractionalChange && (
                <div className='filter'>
                  <div className='trigger'>
                    <label className='trigger__item'>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-fractional'
                        value='integer'
                        checked={!state.isDecimal}
                        onChange={this.handleFractionalChange}
                      />
                      <span className='trigger__text'>0</span>
                    </label>
                    <label className='trigger__item'>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-fractional'
                        value='decimal'
                        checked={state.isDecimal}
                        onChange={this.handleFractionalChange}
                      />
                      <span className='trigger__text'>0.00</span>
                    </label>
                  </div>
                </div>
              )}
              {onPageModeChange ? (
                <div className='filter'>
                  <div className='trigger'>
                    <label className='trigger__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageMode.statistics}
                        checked={this.props.currentPageMode === PageMode.statistics}
                        onChange={onPageModeChange}
                      />
                      <span className='trigger__text'>Статистика</span>
                    </label>
                    <label className='trigger__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageMode.fines}
                        checked={this.props.currentPageMode === PageMode.fines}
                        onChange={onPageModeChange}
                      />
                      <span className='trigger__text'>Штрафы</span>
                    </label>
                  </div>
                </div>
              ) : null}
              {onPageModeCalendarChange ? (
                <div className='filter'>
                  <div className='trigger'>
                    <label className='trigger__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeCalendar.accounts}
                        checked={this.props.currentPageMode === PageModeCalendar.accounts}
                        onChange={onPageModeCalendarChange}
                      />
                      <span className='trigger__text'>Анкеты</span>
                    </label>
                    <label className='trigger__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeCalendar.operators}
                        checked={this.props.currentPageMode === PageModeCalendar.operators}
                        onChange={onPageModeCalendarChange}
                      />
                      <span className='trigger__text'>Операторы</span>
                    </label>
                    {this.store.auth.accessLevel === ACCESS_LEVEL.agency ? (
                    <label className='trigger__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeCalendar.clients}
                        checked={this.props.currentPageMode === PageModeCalendar.clients}
                        onChange={onPageModeCalendarChange}
                      />
                      <span className='trigger__text'>Клиенты</span>
                    </label>
                    ) : null}
                  </div>
                </div>
              ) : null}
              {onDateModeCalendarChange ? (
                <div className='filter'>
                  <div className='trigger'>
                    <label className='trigger__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-datemode'
                        value={DateModeCalendar.days}
                        checked={this.props.currentDateMode === DateModeCalendar.days}
                        onChange={onDateModeCalendarChange}
                      />
                      <span className='trigger__text'>Дни</span>
                    </label>
                    <label className='trigger__item' style={{ minWidth: 80 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-datemode'
                        value={DateModeCalendar.monthes}
                        checked={this.props.currentDateMode === DateModeCalendar.monthes}
                        onChange={onDateModeCalendarChange}
                      />
                      <span className='trigger__text'>Месяцы</span>
                    </label>
                  </div>
                </div>
              ) : null}
              {onPageModeTransfersChange ? (
                <div className='filter'>
                  <div className='trigger'>
                    <label className='trigger__item' style={{ minWidth: 70 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeTransfers.manager}
                        checked={this.props.currentPageMode === PageModeTransfers.manager}
                        onChange={onPageModeTransfersChange}
                      />
                      <span className='trigger__text'>Менеджер</span>
                    </label>
                    <label className='trigger__item' style={{ minWidth: 70 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeTransfers.teamlead}
                        checked={this.props.currentPageMode === PageModeTransfers.teamlead}
                        onChange={onPageModeTransfersChange}
                      />
                      <span className='trigger__text'>Тимлид</span>
                    </label>
                    <label className='trigger__item' style={{ minWidth: 70 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeTransfers.operator}
                        checked={this.props.currentPageMode === PageModeTransfers.operator}
                        onChange={onPageModeTransfersChange}
                      />
                      <span className='trigger__text'>Оператор</span>
                    </label>
                  </div>
                </div>
              ) : null}
              {onPageModeReportsChange && isManagerOrAgency ? (
                <div className='filter'>
                  <div className='trigger'>
                    <label className='trigger__item' style={{ minWidth: 70 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeReports.reports}
                        checked={this.props.currentPageMode === PageModeReports.reports}
                        onChange={onPageModeReportsChange}
                      />
                      <span className='trigger__text'>Отчеты</span>
                    </label>
                    <label className='trigger__item' style={{ minWidth: 70 }}>
                      <input
                        className='trigger__input'
                        type='radio'
                        name='trigger-pagemode'
                        value={PageModeReports.charts}
                        checked={this.props.currentPageMode === PageModeReports.charts}
                        onChange={onPageModeReportsChange}
                      />
                      <span className='trigger__text'>Графики</span>
                    </label>
                  </div>
                </div>
              ) : null}
              {withSearch && (
                <div className='filter'>
                  <div className='search'>
                    <div className='search__input input'>
                      <Observer>
                        {() => (
                          <input
                            id='main-search'
                            type='text'
                            placeholder={this.t('search')}
                            onChange={this.handleSearch}
                          />
                        )}
                      </Observer>
                      <SearchIcon />
                    </div>
                  </div>
                </div>
              )}
              {withTransferSearch && (
                <div className='filter'>
                  <div className='search'>
                    <div className='search__input input'>
                      <Observer>
                        {() => (
                          <input
                            id='main-search'
                            type='text'
                            placeholder={this.t('search')}
                            onChange={v => this.props.onSearchChange(v.target.value)}
                            onKeyDown={event => {
                              if (event.key === 'Enter') {
                                this.props.onSearchEnter();
                              }
                            }}
                          />
                        )}
                      </Observer>
                      <SearchIcon />
                    </div>
                  </div>
                </div>
              )}
              {withAdd ? (
                <div className='filter' style={{ verticalAlign: 'middle' }}>
                  <button type='button' className='filter-columns__save' onClick={onAdd}>
                    Добавить
                  </button>
                </div>
              ) : null}
            </div>
          }
          {this.props.render ? this.props.render() : null}
        </div>
        </div>
      </div>
    );
  }
}

export default Component({ namespaces: ['tableFilter'] })(TableFilter);
